import { useCallback } from "react";
import {
  SCORE_EXPLAINER_TITLE,
  SCORE_EXPLAINER_BODY,
  SCORE_EXPLAINER_CTA,
  SCORE_EXPLAINER_DETAIL,
} from "@hicya/habits-shared/data";

import { ScoreRing } from "@/components/ui/score-ring";
import { useHabits } from "@/context/habits-context";

import styles from "./score-explainer.module.scss";

interface ScoreExplainerProps {
  averageScore: number;
  onDismiss: () => void;
}

export function ScoreExplainer({ averageScore, onDismiss }: ScoreExplainerProps) {
  const { updateSettings } = useHabits();

  const handleDismiss = useCallback(() => {
    void updateSettings("scoreRevealed", "true");
    onDismiss();
  }, [updateSettings, onDismiss]);

  return (
    <div className={styles.overlay} data-testid="score-explainer">
      <div className={styles.content}>
        <div className={styles.scoreRingWrapper}>
          <ScoreRing score={averageScore} size={96} strokeWidth={5}>
            <span className={styles.scoreLabel}>{Math.round(averageScore * 100)}</span>
          </ScoreRing>
        </div>

        <p className={styles.title}>{SCORE_EXPLAINER_TITLE}</p>
        <p className={styles.body}>{SCORE_EXPLAINER_BODY}</p>
        <p className={styles.detail}>{SCORE_EXPLAINER_DETAIL}</p>

        <button
          type="button"
          className={styles.ctaButton}
          onClick={handleDismiss}
          data-testid="score-explainer-dismiss"
        >
          {SCORE_EXPLAINER_CTA}
        </button>
      </div>
    </div>
  );
}
